(function () {
  function ManualRegistrationController($filter, $mdToast, $q, $rootScope, $timeout, Cliente, Endereco, NfeService, Pedido, Perfil) {
    var ctrl = this;

    this.user = Perfil.getCacheUserData();

    this.$onChanges = function (changes) {
      this.encomendaManual = {};
      this.enderecoNfe = null;
      this.alterouEnderecoCorreios = false;
      this.isCepPreenchido = false;
      this.setPessoaJuridica();
      this.utilizarServicoOpcional = false;
      this.loadingServicoEnvio = false;
      this.anulaServicosAdicionais();
      this.pedidoId = null;
      this.reutilizarCodigoRastreamento = true;
      this.desejaContratarSeguro = true;
      this.podeReutilizarCodigo = null;
      this.erroNfe = false;
      this.buscandoOn = true;
      this.exibeLoadingNovaBusca = false;
      this.erroCep = null;
      this.confirmarCadastro = false;
      this.nfeInvalida = false;

      if (changes.encomenda && changes.encomenda.currentValue) {
        carregaDados(changes.encomenda, this.user);
      }
    }

    function carregaDados(encomendaParam, userParam) {
      var chaveAcessoNfeValue = encomendaParam.currentValue.chaveAcessoNfe;
      if (chaveAcessoNfeValue) {
        carregaNfe(chaveAcessoNfeValue, userParam, true);
      }
      if(encomendaParam.currentValue.unidade){
        carregaPedido(encomendaParam.currentValue.unidade);
      }
      carregaCliente(userParam,encomendaParam);
    }

    function carregaNfe(chaveAcessoNfeParam, userParam, exibeErro) {
      ctrl.loadingNfe = true;
      ctrl.erroNfe = false;
      $q.all([
        NfeService.busca(userParam.id, chaveAcessoNfeParam).catch(function (err) {
          if(exibeErro) ctrl.erroNfe = true;
          return $q.resolve({ data: null });
        })
      ]).then(function (dados) {
        ctrl.loadingNfe = false;
        var nfe = dados[0].data;

        if (nfe) {
          preencheCamposAtravesNfe(nfe, chaveAcessoNfeParam);
        } else {
          limpaCamposPreenchidosAtravesNfe();
        }
      }, function () {
        ctrl.loadingNfe = false;
      });
    }

    function preencheCamposAtravesNfe(nfeParam, chaveAcessoNfeParam) {
      ctrl.encomendaManual.destinatario = { endereco: {} };
      ctrl.encomendaManual.destinatario.endereco.complemento = nfeParam.buyer.address.additionalInformation;
      ctrl.encomendaManual.destinatario.nome = nfeParam.buyer.name;
      ctrl.encomendaManual.destinatario.email = nfeParam.buyer.email;

      var isPJ = nfeParam.buyer.federalTaxNumber.length > 11 || !!nfeParam.buyer.stateTaxNumber;
      var cpf = ('0'.repeat(isPJ ? 14 : 11) + nfeParam.buyer.federalTaxNumber).substr(isPJ ? -14 : -11);

      ctrl.encomendaManual.destinatario.cpf = cpf;
      ctrl.encomendaManual.chaveAcessoNFe = chaveAcessoNfeParam;
      ctrl.valorNFe = nfeParam.totals.icms.productAmount;

      Endereco.getAddress(nfeParam.buyer.address.postalCode).then(function (resultado) {
        var endereco = resultado.enderecosEncontrados.length > 0 ? resultado.enderecosEncontrados[0] : null;
        if (!endereco || endereco.desabilita)
          return;

        endereco.numero = nfeParam.buyer.address.number;
        ctrl.preencheEndereco(endereco);

        ctrl.enderecoNfe = Object.assign({}, ctrl.encomendaManual.destinatario.endereco);
        ctrl.encomendaManual.destinatario.endereco = null;
      }).catch(function (erro) {
        ctrl.erroCep = erro.data.erro;
      });
      ctrl.resetValorDeclarado();
    }

    function carregaPedido(unidadeParam) {
      $q.all([
        Pedido.getChegouMandae(unidadeParam.id).catch(function () {
          return $q.resolve({ id: null });
        })
      ]).then(function (dados) {
        var pedido = dados[0];
        ctrl.pedidoId = pedido.id;
      });
    }

    function carregaCliente(userParam, encomendaParam) {
      $q.all([
        Cliente.getPrefixos(userParam.id).catch(function () {
          return $q.resolve({ prefixos: [] });
        })
      ]).then(function (dados) {
        var prefixos = dados[0].prefixos;
        ctrl.podeReutilizarCodigo = prefixos.some(function (prefixo) {
          return this.codigoRastreamento.startsWith(prefixo);
        }, encomendaParam.currentValue);
      });
    }

    function limpaCamposPreenchidosAtravesNfe(){
      ctrl.encomendaManual.destinatario = null;
      ctrl.valorNFe = null;
      ctrl.enderecoNfe = null;  
    }

    this.setPessoaJuridica = function () {
      this.pessoaJuridica = this.encomendaManual.destinatario != null && this.encomendaManual.destinatario.cpf != null && this.encomendaManual.destinatario.cpf.length == 14;
    }

    this.formatCep = function (cep) {
      return $filter('cep')(cep);
    }

    this.changeEnderecoCorreios = function () {
      this.alterouEnderecoCorreios = true;
    }

    this.getLocation = function (address) {
      this.buscandoOn = false;
      if (!isNaN(address.replace('-', ''))) {
        address = address.replace("-", "");
      }
      return Endereco.getAddress(address.toLowerCase())
        .then(function (data) {
          ctrl.buscandoOn = true;
          if (data.usouSugestao) {
            var sugestao = data.enderecosEncontrados;
            var obj = {
              'enderecoFormatado': 'Se você não encontrou o endereço, busque pelo CEP',
              'desabilita': true
            };
            sugestao.unshift(obj);
            return sugestao;
          } else {
            return data.enderecosEncontrados;
          }
        })
        .catch(function (err) {
          ctrl.buscandoOn = true;
          // vm.tratarErrosBackEnd(err);
          var erroFormatado = [{ 'enderecoFormatado': err.data.erro, 'desabilita': true }];

          return erroFormatado;
        });
    }

    this.preencheEndereco = function (item) {
      ctrl.erroCep = null;
      if (item.desabilita) {
        ctrl.encomendaManual.destinatario.endereco.cep = null;
      } else {
        ctrl.isCepPreenchido = true;

        ctrl.encomendaManual.destinatario.endereco.cep = item.cep;
        ctrl.encomendaManual.destinatario.endereco.logradouro = item.logradouro;
        ctrl.encomendaManual.destinatario.endereco.numero = item.numero ? item.numero : null;
        ctrl.encomendaManual.destinatario.endereco.bairro = item.bairro;
        ctrl.encomendaManual.destinatario.endereco.cidade = item.cidade;
        ctrl.encomendaManual.destinatario.endereco.uf = item.estado;
        ctrl.encomendaManual.destinatario.endereco.estado = item.estado;

        ctrl.showSedex10Message = false;
        ctrl.alterouEnderecoCorreios = false;
        ctrl.loadingServicoEnvio = true;

        return Pedido.obterOpcoes(item.cep.replace('-', ''))
          .then(function (tiposEntrega) {
            ctrl.loadingServicoEnvio = false;
            ctrl.podeEscolherFormaEnvio = true;
            ctrl.indicadorPrecoMaximo = tiposEntrega.inidicadorPrecoMaximo;
            ctrl.mensagemPostagem = tiposEntrega.mensagemPostagem;
            ctrl.observacao = tiposEntrega.observacao;
            ctrl.atualizaTipoEntrega(tiposEntrega.opcoes);
          })
          .catch(function (err) {
            ctrl.loadingServicoEnvio = false;
            ctrl.exibeErroBuscaServicos = true;
          });
      }
    }

    this.resetEnderecoPreenchido = function() {
      if(this.utilizarEnderecoNFe) {
        this.encomendaManual.destinatario.endereco = Object.assign({}, this.enderecoNfe);
      } else {
        this.encomendaManual.destinatario.endereco = null;
      }
    }

    this.validaChaveNfePreenchida = function() {
      ctrl.nfeInvalida = false;
      ctrl.erroNfe = false;
      var chaveNfe = this.encomenda.chaveAcessoNfe;

      if(chaveNfe != null && chaveNfe != '' && chaveNfe.length == 44 && ("55" == chaveNfe.substring(20,22) || "99" == chaveNfe.substring(20,22))){
       
        const pesos = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        
        var base = chaveNfe.substring(0, 43);
        var existingDigit = parseInt(chaveNfe.substring(43, 44));
        var digitCalculated = 0;
        var somatoria = 0;
   
        for (let i = 0; i < 43; i++) {
          somatoria+= pesos[i] * parseInt(base.substring(i, i+ 1));
        }
   
        var resto = somatoria% 11;
   
        if(resto<= 1) {
          digitCalculated= 0;
        }else{
          digitCalculated = 11 - resto;
        }
   
        if(existingDigit != digitCalculated) {
          ctrl.nfeInvalida = true;
        }else{
          carregaNfe(chaveNfe, this.user, false);
        } 
      } else {
        ctrl.nfeInvalida = true;
        ctrl.loadingNfe = false;
        ctrl.isCepPreenchido = false;
        ctrl.utilizarEnderecoNFe = false;
        limpaCamposPreenchidosAtravesNfe();
      }
    }

    this.atualizaTipoEntrega = function (tiposEntrega) {
      var mandaeExpress = $filter('filter')(tiposEntrega, {
        codigo: 'MandaeExpress'
      }, true)[0];

      this.servicoSemPrazo = !mandaeExpress || !mandaeExpress.prazoConhecido;


      tiposEntrega.forEach(function (tipo) {
        if (tipo.nomeFormatado.indexOf('(') > 0)
          tipo.nomeFormatado = tipo.nomeFormatado.substring(0, tipo.nomeFormatado.indexOf('(')) + 'após a postagem';
      });
      this.tiposEntrega = tiposEntrega;
    }

    this.setServico = function (servico) {
      this.encomendaManual.servicoEnvio = servico.codigo;
      this.encomendaManual.prazoMaximo = servico.prazoMaximo;
      this.encomendaManual.prazoMinimo = servico.prazoMinimo;

      this.taxaValorDeclarado = servico.percentualValorDeclarado;
      this.valorDeclaradoMinimo = servico.valorDeclaradoMinimo;
      this.valorDeclaradoMaximo = servico.valorDeclaradoMaximo;
      this.valorDeclaradoNomeExibicao = servico.nomeExibicao;
      this.changeValorDeclarado();
    }

    this.resetValorDeclarado = function () {
      if (!this.desejaContratarSeguro) {
        delete this.encomendaManual.valorDeclarado;
      } else {
        this.encomendaManual.valorDeclarado = this.valorNFe;
        this.changeValorDeclarado();
      }
    }

    this.calculaValorDeclaradoAdicional = function (valorDeclarado) {
      var adicional = (this.taxaValorDeclarado / 100) * valorDeclarado;
      return adicional > 0 ? adicional : 0;
    }

    this.changeValorDeclarado = function () {
      if (this.valorDeclaradoMaximo) {
        this.valorDeclaradoAdicional = this.calculaValorDeclaradoAdicional(this.encomendaManual.valorDeclarado);
      }
    }

    this.criaCifroes = function (n) {
      if (n) {
        return '<font color="#BBBBBB">' + '$'.repeat(n) + '</font>';
      }

      return '';
    }

    this.showServicosAdicionais = function () {
      this.utilizarServicoOpcional = !this.utilizarServicoOpcional;
      if (!this.utilizarServicoOpcional) {
        this.anulaServicosAdicionais();
      }
    }

    this.anulaServicosAdicionais = function () {
      this.encomendaManual.referencia = null;
    }

    this.cadastrar = function (form) {
      if (!this.confirmarCadastro) {
        return;
      }

      if (!form.$valid) {
        return;
      }

      this.exibeLoadingNovaBusca = true;

      var touched = false;
      var trimRecursive = function (obj) {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            var element = obj[key];

            if (typeof(element) === 'object') {
              trimRecursive(element);
            }

            if (typeof(element) !== 'string') {
              continue;
            }

            obj[key] = element.trim();
            if (obj[key] !== element) {
              touched = true;
            }
          }
        }
      };

      trimRecursive(this.encomendaManual);
      if (touched) {
        $timeout((function () {
          this.cadastrar();
        }).bind(this), 0);
        this.exibeLoadingNovaBusca = false;
        return;
      }

      // se usou cpf.
      if (this.encomendaManual.destinatario.cpf) {
        // Pega o cpf ou cnpj.
        var cpf = this.encomendaManual.destinatario.cpf.length == 11 ? this.encomendaManual.destinatario.cpf : null;
        var cnpj = this.encomendaManual.destinatario.cpf.length == 14 ? this.encomendaManual.destinatario.cpf : null;

        if (cpf) {
          this.encomendaManual.destinatario.tipoPessoa = 'fisica';
          this.encomendaManual.destinatario.inscricaoEstadual = null;
        } else {
          this.encomendaManual.destinatario.tipoPessoa = 'juridica';
        }

        this.encomendaManual.destinatario.cpf = cpf;
        this.encomendaManual.destinatario.cnpj = cnpj;
      }

      if (this.podeReutilizarCodigo && this.reutilizarCodigoRastreamento) {
        this.encomendaManual.codigoRastreamento = this.encomenda.codigoRastreamento;
      } else {
        delete this.encomendaManual.codigoRastreamento;
      }
      // seta email destintario
      this.encomendaManual.destinatario.email = this.encomendaManual.destinatario.email ? this.encomendaManual.destinatario.email : null;

      Pedido.cadastroManual(Object.assign({
        pedidoId: this.pedidoId,
        naoEncontrada: this.encomenda.codigoRastreamento,
        mandaeEscolhe: true,
        tipoDocumentoOrigem: 'NFe',
        chaveAcessoNFe: this.encomenda.chaveAcessoNfe,
      }, this.encomendaManual))
        .then(function () {
          var toast = $mdToast.simple()
            .textContent('Encomenda cadastrada')
            .highlightAction(true)
            .parent('[data-container="toast"]')
            .position('top right')
            .hideDelay(5000);

            ctrl.exibeLoadingNovaBusca = false;
          $rootScope.$emit('refresh:nao_encontrada');
          $rootScope.$emit('manual_registration:close');
          return $mdToast.show(toast);
        }, function (e) {
          ctrl.exibeLoadingNovaBusca = false;

          if (e && e.data && e.data.erros) {
            var mensagem = '';
            for (var key in e.data.erros) {
              if (e.data.erros.hasOwnProperty(key)) {
                mensagem = e.data.erros[key];
                break;
              }
            }

            if (mensagem) {
              var toast = $mdToast.simple()
                .textContent('Erro: ' + mensagem)
                .highlightAction(true)
                .parent('[data-container="toast"]')
                .position('top right')
                .hideDelay(10000);

              return $mdToast.show(toast);
            }
          }
          console.error(e);
        });
      }
    }   

  angular.module('mandaeApp')
    .component('manualRegistration', {
      template: require('./manual-registration.html'),
      controller: ['$filter', '$mdToast', '$q', '$rootScope', '$timeout', 'Cliente', 'Endereco', 'NfeService', 'Pedido', 'Perfil', ManualRegistrationController],
      bindings: {
        encomenda: '<',
      },
    })
    .directive('somenteNumero', somenteNumero);

    function somenteNumero() {
      return {
        require: "ngModel",
        link: function (scope, element, attr, ngModelCtrl) {
          function fromUser(text) {
            if (text) {
              var transformedInput = text.replace(/[^0-9]/g, "");  
              if (transformedInput !== text) {
                ngModelCtrl.$setViewValue(transformedInput);
                ngModelCtrl.$render();
              }
              return transformedInput;
            }
            return undefined;
          }
          ngModelCtrl.$parsers.push(fromUser);
        },
      };
    }
})();
